module.exports = __webpack_public_path__ + "img/menu-4.403decf2.svg";